import { Calendar, ListTodo, UserPlus, Users } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { ScreenHeader } from '../components/layout/ScreenHeader';
import TransitionLink from '../components/TransitionLink';
import { useTransitionNavigate } from '../hooks/useTransitionNavigate';

type NewLocationState = { clientId?: string; from?: string } | null;

const NewPage = () => {
  const { t } = useTranslation();
  const navigate = useTransitionNavigate();
  const location = useLocation();
  const state = location.state as NewLocationState;
  const clientId = state?.clientId;
  const from = state?.from;
  const backTo = from && from !== '/new' && !from.startsWith('/new?')
    ? from
    : clientId
      ? `/clients/${clientId}`
      : '/';

  const items = [
    {
      label: t('Записать на тренировку'),
      icon: Calendar,
      to: '/bookings/new',
      state: clientId ? { clientId } : undefined,
    },
    { label: t('Пригласить клиента'), icon: UserPlus, to: '/clients/invite', state: undefined },
    { label: t('Новый потенциальный клиент'), icon: Users, to: '/leads/new', state: undefined },
    {
      label: t('Новая задача'),
      icon: ListTodo,
      to: clientId ? `/tasks/new?clientId=${clientId}` : '/tasks/new',
      state: undefined,
    },
  ] as const;

  return (
    <div className="page-container max-w-lg">
      <ScreenHeader title={t('Что добавить?')} onBack={() => navigate(backTo)} backLabel={t('Назад')} />
      <div className="grid gap-3">
        {items.map((item) => {
          const Icon = item.icon;
          return (
            <TransitionLink
              key={item.label}
              to={item.to}
              state={item.state}
              className="card p-5 flex items-center gap-4 font-semibold text-slate-900"
            >
              <Icon size={22} className="text-primary shrink-0" />
              <span>{item.label}</span>
            </TransitionLink>
          );
        })}
      </div>
    </div>
  );
};

export default NewPage;
